module.exports = __webpack_public_path__ + "img/VRP-logo-ems.2b53011f.svg";